import React from "react";
import { Link } from "react-scroll";
import { ListItem, List, makeStyles } from "@material-ui/core";
import flare from "../../Assets/flareBottom.png";
import "../../CSS/Menu.css";

const useStyles = makeStyles((theme) => ({
  active: {
    backgroundImage: `url(${flare})`,
    backgroundPosition: "center bottom",
    backgroundRepeat: "no-repeat",
    backgroundSize: "200px 100px",
    transition: "all 0.5s ease",
  },
}));

export default function DesktopNavbar(props) {
  const items = props.items;

  const classes = useStyles();
  return (
    <>
      <div className="listOutterDiv">
        <List dense className="list">
          {items.map((item) => {
            return (
              <ListItem
                button
                spy
                smooth
                offset={-200}
                activeClass={classes.active}
                component={Link}
                to={item}
                key={item}
              >
                {item}
              </ListItem>
            );
          })}
        </List>
      </div>
    </>
  );
}
